module.exports = __webpack_public_path__ + "static/media/rain.3bb95a17.gif";